import React from "react";

import { Checkbox } from "@/components/ui/checkbox";
import TagList from "components/TagList";
import { SELECT_COLUMN_ID } from "constants/Constants";
import { TableLink } from "components/BaseTableV3/TableLink";
import RuvixxDate from "components/RuvixxDate";
import { EmailSignatureTableActions } from "./EmailSignatureTableActions";
import { invalidateEmailSignatureTableQuery } from "hooks/useEmailSignatureTable";
import { EMAIL_SIGNATURE_TABLE_CONSTANTS } from "routes/email/EmailSignatureTableV3";

export const getEmailSignatureTableColumns = () => {
  return [
    {
      id: SELECT_COLUMN_ID,
      size: 50,
      enableSorting: false,
      meta: {
        isDisplay: true,
      },
      header: ({ table }) => (
        <Checkbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onCheckedChange: checked => table.toggleAllRowsSelected(!!checked),
            "aria-label": "Select all rows",
          }}
        />
      ),
      cell: ({ row }) => (
        <div>
          <Checkbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected() && !row.getIsSelected(),
              onCheckedChange: checked => row.toggleSelected(!!checked),
              "aria-label": "Select row",
            }}
          />
        </div>
      ),
    },
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Tags",
      id: "Tags",
      accessorKey: "tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.original.tags}
          modelType={EMAIL_SIGNATURE_TABLE_CONSTANTS.className}
          modelId={row.original.id}
          tableCell
          onUpdate={invalidateEmailSignatureTableQuery}
        />
      ),
    },
    {
      header: "Email Signature Name",
      id: "Email Signature Name",
      accessorKey: "name",
      cell: ({ row }) => (
        <TableLink href={`/settings/email_signatures/${row.original.id}`}>
          {row.original.name}
        </TableLink>
      ),
    },
    {
      header: "Created At",
      id: "Created At",
      accessorKey: "created_at",
      cell: ({ row }) => {
        const value = row.original?.created_at;
        if (value !== undefined && value !== null) {
          return <RuvixxDate date={value} />;
        }
        return null;
      },
    },
    {
      header: "Updated At",
      id: "Updated At",
      accessorKey: "updated_at",
      cell: ({ row }) => {
        const value = row.original?.updated_at;
        if (value !== undefined && value !== null) {
          return <RuvixxDate date={value} />;
        }
        return null;
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <EmailSignatureTableActions original={row.original} />,
    },
  ];
};

export const getEmailSignatureTableFilters = ({ tags }) => {
  return [
    {
      key: "tag_id",
      title: "Tag",
      type: "tag",
      data: tags,
    },
  ];
};
